var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e60023;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pinterest"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pinterest-2",
    "data-name": "Pinterest",
    className: "cls-2",
    d: "M109.16,612.63c-29.87,0-45.41,19.92-45.41,41.82,0,10.16,5.18,22.71,13.94,26.69,1.2.8,2,.4,2-.8l2-7.56c.2-1,.2-1.6-.4-2a26.31,26.31,0,0,1-5.18-15.94c0-15.33,11.55-29.87,31.07-29.87,17.13,0,29.08,11.35,29.08,27.88,0,18.72-9.56,31.87-21.91,31.87A10.6,10.6,0,0,1,103.78,672c2-8.17,6-16.73,6-22.7,0-5.58-2.79-10-8.77-10-6.77,0-12.74,7.17-12.74,16.73a25,25,0,0,0,2,10.35l-8,34.26c-1.19,6.17-.59,15.14,0,20.51.09.94.56,2.58,1.76,2.81a2.66,2.66,0,0,0,2.53-1.39c3-4.79,7.28-12.64,8.86-18.55l4.78-16.53c2.19,4.39,8.76,8,15.53,8,21.11,0,35.85-19.12,35.85-43C151.58,629.76,133.06,612.63,109.16,612.63Z",
    transform: "translate(0 -554)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/Pinterest.608d38ab95222d2b02cfeaf8d9d95b15.svg";
export { ForwardRef as ReactComponent };